import { api } from './client';
import { getImageUrlById } from './images';
import type { CommitteeMember, CommitteeMemberType } from '../features/committee/types';
export type { CommitteeMember, CommitteeMemberType } from '../features/committee/types';

export function getCommitteeMemberImageUrl(member: CommitteeMember): string {
  return getImageUrlById(member.imageId) || '';
}

export async function getCommittee(): Promise<CommitteeMember[]> {
  return api.get<CommitteeMember[]>('/api/committee');
}

export async function createCommitteeMember(data: {
  firstName: string;
  lastName: string;
  position: string;
  description?: string | null;
  memberType?: CommitteeMemberType;
  imageId?: string | null;
  userId?: string | null;
  displayOrder?: number;
}): Promise<CommitteeMember> {
  return api.post<CommitteeMember>('/api/committee', data);
}

export async function updateCommitteeMember(
  id: string,
  data: Partial<{
    firstName: string;
    lastName: string;
    position: string;
    description: string | null;
    memberType: CommitteeMemberType;
    imageId: string | null;
    userId: string | null;
    displayOrder: number;
  }>
): Promise<CommitteeMember> {
  return api.patch<CommitteeMember>(`/api/committee/${id}`, data);
}

export async function deleteCommitteeMember(id: string): Promise<void> {
  return api.delete(`/api/committee/${id}`);
}
